import { SvgIcon, SvgIconProps } from '@/theme/index';

export function PinterestIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 18 18" {...props}>
      <g
        id="Footer-OPT1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-414.000000, -470.000000)"
      >
        <g
          id="Footer-Tablet"
          transform="translate(48.000000, 49.000000)"
          fill="#CC2127"
        >
          <g id="SocialMedia" transform="translate(1.000000, 421.000000)">
            <path
              d="M374.000529,0 C369.03034,0 365,4.02928206 365,9.00052919 C365,12.6847769 367.216264,15.8514729 370.388252,17.2432528 C370.362851,16.6156289 370.384018,15.85994 370.543835,15.1762216 C370.71741,14.445934 371.701711,10.2727112 371.701711,10.2727112 C371.701711,10.2727112 371.414888,9.6980067 371.414888,8.84812136 C371.414888,7.51455283 372.188569,6.51860998 373.150644,6.51860998 C373.968778,6.51860998 374.364615,7.13353325 374.364615,7.87017111 C374.364615,8.69253837 373.839654,9.92344329 373.569765,11.0633269 C373.344329,12.019051 374.048157,12.796966 374.990122,12.796966 C376.695184,12.796966 377.843535,10.6071618 377.843535,8.01199506 C377.843535,6.04021873 376.515258,4.56376786 374.098959,4.56376786 C371.369377,4.56376786 369.668548,6.59904745 369.668548,8.87246428 C369.668548,9.65778797 369.899277,10.2102664 370.261245,10.637855 C370.428471,10.8357735 370.450697,10.9140942 370.390369,11.1405892 C370.348033,11.3046393 370.248545,11.7047098 370.207268,11.8624096 C370.146939,12.089963 369.96278,12.1725172 369.757453,12.0878462 C368.49903,11.5745281 367.913741,10.1975657 367.913741,8.64914447 C367.913741,6.09313812 370.069677,3.0259305 374.345564,3.0259305 C377.782149,3.0259305 380.043923,5.51420004 380.043923,8.18239548 C380.043923,11.7131769 378.081672,14.3506791 375.186982,14.3506791 C374.21644,14.3506791 373.301993,13.8257188 372.988711,13.2298465 C372.988711,13.2298465 372.465867,15.3032281 372.355795,15.7032986 C372.165285,16.3965426 371.791674,17.0908449 371.449815,17.6306227 C372.259481,17.8698183 373.114659,18 374.000529,18 C378.970718,18 383,13.9707179 383,9.00052919 C383,4.02928206 378.970718,0 374.000529,0"
              id="Pinterest"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
